import { staticText } from '../../../utils/translations/staticText';

export const moneyHeroTranslation = staticText({
  sta_bka_bank_gift: {
    _: `Provider Gift - On Top of MoneyHero's`,
    zh: '產品禮遇',
  },
  bank_gift: {
    _: `Bank Gift - On Top of MoneyHero's`,
    zh: '產品禮遇',
  },
  brand_reward: {
    _: 'MoneyHero Reward',
    zh: 'MoneyHero獎賞價值',
  },
  brand_reward_guidance: {
    _: 'MoneyHero Reward',
    zh: 'MoneyHero 獨家獎勵',
  },
  apply_through: {
    _: 'Apply through MoneyHero and choose from :count premium rewards',
    zh: '「經MoneyHero申請,精選獎賞任你揀!獎賞選擇(:count) 」',
  },
  apply_through_ci: {
    _: 'Apply through MoneyHero and choose from <b>:count premium rewards:</b>',
    zh: '「經MoneyHero申請,精選獎賞任你揀!獎賞選擇(<b>:count</b>) 」',
  },
  apply_through_stk_bka: {
    _: 'Apply through MoneyHero and choose from :count premium rewards (Actual Gift eligibility depends on the deposit amount provided in the terms and conditions)',
    zh: '經MoneyHero申請，精選獎賞任你揀！獎賞選擇 :count (實際獎賞資格須視乎條款及細則所列的存款金額而定)',
  },
  purchase_through: {
    _: 'Purchase through MoneyHero and choose from :count premium rewards',
    zh: '經MoneyHero投保 ，精選獎賞任你揀！獎賞選擇(:count)',
  },
  brand_take: {
    _: `MoneyHero's take`,
    zh: 'MoneyHero 產品分析',
  },
  provider_gift_info: {
    _: `You'll also receive the following welcome gift(s) directly from the provider`,
    zh: `金融機構亦會賞你以下迎新優惠`,
  },
  update_amount_tenure: {
    _: 'Update Loan Amount / Tenure to Qualify',
    zh: '更新貸款金額/期限以符合條件',
  },
  amount_tenure_price_unlock_reward: {
    _: 'Update your loan amount to at least <b>:prefix:amount</b> and loan tenure to at least <b>:tenure month</b> to unlock exclusive gifts worth up to <b>:prefix:maxReward</b>.',
    zh: '請將您的貸款金額調整至至少 <b>:prefix:amount</b>，並將貸款期限更新至至少 <b>:tenure 個月</b>，以解鎖最高可獲得 <b>:prefix:maxReward</b> 的獨家禮品。',
  },
  amount_tenure_unlock_reward: {
    _: 'Update your loan amount to at least <b>:prefix:amount</b> and loan tenure to at least <b>:tenure month</b> to unlock exclusive gifts.',
    zh: '請將您的貸款金額調整至至少 <b>:prefix:amount</b>，並將貸款期限更新至至少 <b>:tenure 個月</b>，以解鎖獨家禮品。',
  },
  amount_unlock_reward: {
    _: 'Update your loan amount to at least <b>:prefix:amount</b> to unlock exclusive gifts',
    zh: '請將您的貸款金額調整至至少 <b>:prefix:amount</b>，以解鎖獨家禮品。',
  },
  tenure_unlock_reward: {
    _: 'Update your loan tenure to at least <b>:tenure month</b> to unlock exclusive gifts',
    zh: '請將您的貸款期限更新至至少 <b>:prefix:amount</b>，以解鎖獨家禮品。',
  },
  worth_up_reward: {
    _: '<b>worth up to :prefix:reward</b>',
    zh: '<b>:prefix:reward 的獨家禮品。</b>',
  },
  // HK quotes its base price off its own reference profile, so it must not
  // inherit the SG one from the base translations (INS-6583).
  static_pricing_default_tooltip: {
    _: 'Based on a 2022 Honda Jazz, a 35-year-old owner with 5 years of driving experience and a NCD of 60%.',
    zh: '以2022年Honda Jazz、車主35歲、5年駕駛經驗及無索償折扣60%計算',
  },
});
